/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountActiveIntegrationEvents200Response
 */
export interface CountActiveIntegrationEvents200Response {
    /**
     * 
     */
    data?: number;
}

/**
 * Check if a given object implements the CountActiveIntegrationEvents200Response interface.
 */
export function instanceOfCountActiveIntegrationEvents200Response(value: object): value is CountActiveIntegrationEvents200Response {
    return true;
}

export function CountActiveIntegrationEvents200ResponseFromJSON(json: any): CountActiveIntegrationEvents200Response {
    return CountActiveIntegrationEvents200ResponseFromJSONTyped(json, false);
}

export function CountActiveIntegrationEvents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountActiveIntegrationEvents200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function CountActiveIntegrationEvents200ResponseToJSON(json: any): CountActiveIntegrationEvents200Response {
    return CountActiveIntegrationEvents200ResponseToJSONTyped(json, false);
}

export function CountActiveIntegrationEvents200ResponseToJSONTyped(value?: CountActiveIntegrationEvents200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
    };
}

